import React from "react";
import { FormattedMessage } from "react-intl";

import { Button } from "src/common/components/Button";
import { genericMessages } from "src/messages/generic";

import "./Confirm.css";

interface ConfirmProps {
	content: React.ReactNode;
	negativeActions: React.ReactNode;
	positiveActions: React.ReactNode;
}

export const Confirm: React.FunctionComponent<ConfirmProps> = ({
	content,
	negativeActions,
	positiveActions
}) => (
	<div className="confirm">
		<div className="confirm__content">
			<div className="confirm__body">{content}</div>
			<div className="confirm__footer">
				<div className="confirm__footer__side">{negativeActions}</div>
				<div className="confirm__footer__side">{positiveActions}</div>
			</div>
		</div>
	</div>
);

interface ButtonProps {
	onClick(): unknown;
}

export const NoButton: React.FunctionComponent<ButtonProps> = ({ onClick }) => (
	<Button
		type="button"
		variant="secondary"
		className="confirm__button confirm__button--no"
		onClick={onClick}
	>
		<FormattedMessage {...genericMessages.no} />
	</Button>
);

export const YesButton: React.FunctionComponent<ButtonProps> = ({
	onClick
}) => (
	<Button
		type="button"
		variant="primary"
		className="confirm__button confirm__button--yes"
		onClick={onClick}
	>
		<FormattedMessage {...genericMessages.yes} />
	</Button>
);
